<ng-container *ngIf="options">
    <aumico-form [options]="options" [delegate]="this" [data]="DATA"> </aumico-form>
</ng-container>
